(function(){function root(){return window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||"/"}function showError(btn,msg){var box=btn.closest(".tw3-card__foot, .tw3-mini, .tw3-ctas");if(box){var el=box.querySelector(".tw3-err");el||(el=document.createElement("span"),el.className="tw3-err",el.setAttribute("role","status"),box.appendChild(el)),el.textContent=msg}}async function addToCart(ids,btn){btn.setAttribute("aria-busy","true");try{var res=await fetch(root()+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({items:ids.map(function(id){return{id:Number(id),quantity:1}})})});if(!res.ok){var err=await res.json().catch(function(){return{}});throw new Error(err.description||"Ajout impossible")}document.dispatchEvent(new CustomEvent("cart:refresh",{detail:{open:!0}}))}catch(e){showError(btn,e.message||"Ajout impossible")}finally{btn.removeAttribute("aria-busy")}}document.addEventListener("click",function(e){var add=e.target.closest("[data-tw3-add]");if(add){e.preventDefault();var ids=add.getAttribute("data-tw3-add").split(",").filter(Boolean);ids.length&&addToCart(ids,add);return}var pick=e.target.closest("[data-tw3-pick]");if(pick){var box=pick.closest("[data-tw3-finder]"),key=pick.getAttribute("data-tw3-pick");box.querySelectorAll("[data-tw3-pick]").forEach(function(b){b.setAttribute("aria-pressed",b===pick?"true":"false")}),box.querySelectorAll("[data-tw3-set]").forEach(function(s){s.hidden=s.getAttribute("data-tw3-set")!==key});return}var search=e.target.closest("[data-tw3-search]");if(search){var trigger=document.querySelector('.search-drawer-button[aria-controls="SearchDrawer"]');trigger&&(e.preventDefault(),trigger.click())}})})();

/* TreasureWise V3 : recherche (suggestions) et panier latéral */
(function () {
  /* suggestions visibles seulement quand le champ est vide */
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('#SearchDrawer')) return;
    if (t.tagName !== 'INPUT') return;
    var ss = document.querySelector('[data-tw3-ss]');
    if (ss) ss.hidden = t.value.trim() !== '';
  });

  var XS = null;
  function xs() {
    if (XS) return XS;
    try { var el = document.getElementById('tw3-xsell'); XS = { title: el.getAttribute('data-title') || 'Complète ta protection', items: JSON.parse(el.textContent) }; }
    catch (e) { XS = { title: '', items: [] }; }
    return XS;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function num(t) { var m = String(t || '').replace(/\s/g, '').match(/(\d+(?:[.,]\d{1,2})?)/); return m ? parseFloat(m[1].replace(',', '.')) : 0; }
  function money(v) { return v.toFixed(2).replace('.', ',') + ' €'; }

  var busy = false;
  function enhance() {
    var d = document.getElementById('CartDrawer');
    if (!d || busy) return;
    busy = true;
    try {
      var h = d.querySelector('.drawer__heading > span');
      if (h && /Votre panier/.test(h.textContent)) h.textContent = 'Ton panier';
      var lab = d.querySelector('.free-shipping-goal__label--default');
      if (lab) {
        Array.prototype.forEach.call(lab.childNodes, function (nd) {
          if (nd.nodeType !== 3) return;
          if (/D\u00e9pensez|Depensez/.test(nd.nodeValue)) nd.nodeValue = 'Plus que ';
          else if (/de plus/.test(nd.nodeValue)) nd.nodeValue = ' pour la livraison offerte en point relais';
        });
      }
      var ok = d.querySelector('.free-shipping-goal__label--success');
      if (ok && !ok.__tw3) { ok.textContent = 'Livraison offerte en point relais débloquée'; ok.__tw3 = true; }
      var tot = d.querySelector('.totals__subtotal-value');
      var co = d.querySelector('.drawer__footer-buttons button[name="checkout"], .drawer__footer-buttons .btn--primary');
      if (co && tot) {
        var lbl = 'Passer commande · ' + tot.textContent.trim();
        if (co.textContent.trim() !== lbl) co.textContent = lbl;
      }
      var foot = d.querySelector('.drawer__footer-buttons');
      if (foot && !d.querySelector('.tw3-cart-note')) {
        var n = document.createElement('p');
        n.className = 'tw3-cart-note';
        n.textContent = 'Paiement sécurisé · Expédition sous 1 à 2 jours ouvrés · Retours sous 14 jours';
        foot.parentNode.insertBefore(n, foot.nextSibling);
      }
      /* suggestions */
      var body = d.querySelector('.cart-drawer__body');
      var rec = d.querySelector('cart-drawer-products-recommendation');
      var recShown = rec && !rec.classList.contains('hidden') && rec.offsetHeight > 0;
      var old = d.querySelector('.tw3-cx');
      if (body && !recShown) {
        var inCart = Array.prototype.map.call(d.querySelectorAll('.cart-item__title'), function (a) { return a.getAttribute('href') || ''; }).join(' ');
        var pool = xs().items.filter(function (x) { return inCart.indexOf('/products/' + x.h) < 0; });
        var title = xs().title, list = pool.slice(0, 2);
        /* reste avant la livraison offerte : on propose ce qui comble l'écart, au plus juste */
        var left = 0, st = d.querySelector('[data-left-to-spend]'), pb = d.querySelector('.free-shipping-goal progress-bar');
        if (st) left = num(st.textContent);
        if (pb && Number(pb.getAttribute('data-value')) >= Number(pb.getAttribute('data-max'))) left = 0;
        if (left > 0 && pool.length) {
          pool.forEach(function (x) { x.v = num(x.p); });
          var best = null;
          function consider(l) {
            var s = l.reduce(function (a, x) { return a + x.v; }, 0);
            if (s + 0.001 < left) return;
            var score = s + l.filter(function (x) { return !x.q; }).length * 3;
            if (!best || score < best.score) best = { score: score, l: l };
          }
          pool.forEach(function (a) { consider([a]); });
          for (var i = 0; i < pool.length; i++) for (var k = i + 1; k < pool.length; k++) consider([pool[i], pool[k]]);
          if (best) {
            list = best.l;
            title = 'Pour passer à la livraison offerte (encore ' + money(left) + ') :';
          }
        }
        var sig = list.map(function (x) { return x.id; }).join(',') + '|' + title;
        if (!list.length || !d.querySelector('.cart-item')) { if (old) old.remove(); }
        else if (!old || old.getAttribute('data-sig') !== sig) {
          if (old) old.remove();
          var w = document.createElement('div');
          w.className = 'tw3 tw3-cx';
          w.setAttribute('data-sig', sig);
          w.innerHTML = '<p class="tw3-cx__t">' + esc(title) + '</p>' + list.map(function (x) {
            var btn = x.q
              ? '<button type="button" class="tw3-iconbtn tw3-iconbtn--outline" data-tw3-add="' + x.id + '" aria-label="Ajouter ' + esc(x.n) + ' au panier"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button>'
              : '<a class="tw3-iconbtn tw3-iconbtn--outline" href="' + esc(x.u) + '" aria-label="Choisir ' + esc(x.n) + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
            return '<div class="tw3-cx__i">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" width="52" height="52" loading="lazy">' : '') +
              '<a class="tw3-cx__n" href="' + esc(x.u) + '"><span>' + esc(x.n) + '</span><span>' + esc(x.p) + '</span></a>' + btn + '</div>';
          }).join('');
          body.appendChild(w);
        }
      } else if (old) { old.remove(); }
    } finally { busy = false; }
  }
  function watch() {
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    enhance();
    new MutationObserver(function () { if (!busy) { clearTimeout(watch.t); watch.t = setTimeout(enhance, 30); } }).observe(d, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

/* V3 · jeu retenu (page Jeux compatibles, pages par jeu) : badges « Compatible avec … » */
(function () {
  var KEY = 'tw3_jeu';
  function get() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function dot(n) { return /[!?.]$/.test(n) ? '' : '.'; }
  var CHECK = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>';
  var GN = { 'pokemon': 'Pokémon', 'one-piece': 'One Piece', 'riftbound': 'Riftbound', 'magic': 'Magic', 'lorcana': 'Lorcana' };
  function fromPath(p) { var m = /\/collections\/(?:[a-z0-9-]*-)?(pokemon|one-piece|riftbound|magic|lorcana)(?:[\/?#]|$)/.exec(p || ''); return m ? m[1] : null; }
  (function () {
    /* le jeu suit la page par jeu ouverte, ou celle d'où vient le visiteur (ex. fiche ouverte depuis Classeurs Lorcana) */
    var h = fromPath(location.pathname);
    if (!h && document.referrer) { try { var r = new URL(document.referrer); if (r.host === location.host) h = fromPath(r.pathname); } catch (e) {} }
    if (h) { try { localStorage.setItem(KEY, JSON.stringify({ h: h, n: GN[h] })); } catch (e) {} }
  })();
  function apply() {
    var g = get(), has = !!(g && g.n);
    document.querySelectorAll('[data-tw3-fit]').forEach(function (el) {
      var f = el.getAttribute('data-tw3-fit'), ok = has && (f === 'all' || f === g.h);
      el.hidden = !ok; if (ok) el.innerHTML = CHECK + 'Compatible ' + esc(g.n);
    });
    document.querySelectorAll('[data-tw3-mygame]').forEach(function (el) {
      el.hidden = !has; if (has) el.innerHTML = CHECK + 'Compatible avec ' + esc(g.n) + dot(g.n);
      var def = el.parentNode.querySelector('[data-tw3-mygame-def]'); if (def) def.hidden = has;
    });
    document.querySelectorAll('[data-tw3-mygame-link]').forEach(function (a) {
      if (!a.hasAttribute('data-href0')) a.setAttribute('data-href0', a.getAttribute('href'));
      var href = a.getAttribute('data-href0');
      if (has && g.h && g.h !== 'autre') { try { var u = new URL(href, location.href); u.searchParams.set('jeu', g.h); href = u.pathname + u.search; } catch (e) {} }
      a.setAttribute('href', href); a.textContent = has ? 'Vérifier un autre jeu' : 'Vérifier mon jeu';
    });
    document.querySelectorAll('[data-tw3-fitwarn]').forEach(function (el) {
      var f = el.getAttribute('data-tw3-fitwarn'), show = has && g.h !== f && g.h !== 'autre';
      el.hidden = !show; if (show) el.innerHTML = esc('À savoir : cette protection est faite pour les produits scellés ' + (f === 'pokemon' ? 'Pokémon' : f) + ', pas pour ' + g.n + dot(g.n)) + ' <a href="/collections/all?view=jeux" class="tw3-fitwarn-link">Changer de jeu</a>';
    });
  }
  window.TW3Game = { set: function (h, n) { try { if (h) localStorage.setItem(KEY, JSON.stringify({ h: h, n: n })); else localStorage.removeItem(KEY); } catch (e) {} apply(); }, apply: apply };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();
